import { Severity, captureException, captureMessage } from '@sentry/react';

const logError = (error: Error) => captureException(error);
const logWarning = (warning: string) =>
  captureMessage(warning, Severity.Warning);
const logInfo = (message: string) => captureMessage(message, Severity.Info);

export { logError, logWarning, logInfo };
